import { createApi } from "@reduxjs/toolkit/query/react";

import baseQuery from "./baseQuery";

// Define the base API
export const profileApi = createApi({
  reducerPath: "profileApi",
  baseQuery: baseQuery(),
  tagTypes: ["Profile"], // Define a tag type for cache invalidation
  endpoints: (builder) => ({
    // list profiles API
    listProfiles: builder.query({
      query: () => ({
        url: `/profile`,
      }),
      providesTags: ["Profile"],
    }),
    // create profile API
    createProfile: builder.mutation({
      query: (body) => ({
        url: `/profile`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Profile"],
    }),
    // fetch a profile by id
    fetchProfile: builder.query({
      query: (id) => ({
        url: `/profile/${id}`,
      }),
    }),
    fetchProfileCurrent: builder.query({
      query: () => ({
        url: `/profile/me`,
      }),
      // every consumer (Avatar, TenantInfo, usePermissions) shares this entry, so
      // tagging it is what makes a save anywhere show up everywhere
      providesTags: ["Profile"],
    }),
    // update profile API
    updateProfile: builder.mutation({
      query: ({ id, body }) => ({
        url: `/profile`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Profile"],
    }),
    // delete profile API
    deleteProfile: builder.mutation({
      query: (id) => ({
        url: `/profile/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Profile"],
    }),
  }),
});

export const {
  useListProfilesQuery,
  useCreateProfileMutation,
  useFetchProfileQuery,
  useFetchProfileCurrentQuery,
  useUpdateProfileMutation,
  useDeleteProfileMutation,
} = profileApi;

export default profileApi;
